import { Injectable, Signal, signal } from '@angular/core';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';

/**
 * Visibilidade do header do portal.
 *
 * Quem decide é o portal, pelo parâmetro `MostrarHeader` da URL de entrada (ver
 * `authGuard`). O valor fica no storage para sobreviver a um F5, já que a URL
 * com o parâmetro não se repete nas navegações internas.
 */
@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly _isVisible = signal<boolean>(false);

  readonly isVisible: Signal<boolean> = this._isVisible.asReadonly();

  constructor(private readonly localStorageService: LocalStorageService) {
    const stored = this.localStorageService.get('MostrarHeader');
    this._isVisible.set(stored === 'true');
  }

  setVisible(value: boolean): void {
    this._isVisible.set(value);
    this.localStorageService.add('MostrarHeader', value ? 'true' : 'false');
  }
}
